import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import { TrainingFormsDatatableDocument } from 'generated/resources/datatable.graphql'
import { DeleteFormDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import DeleteModal from 'modules/trainings/components/Revamp/TrainingsDetail/Forms/AllFormsDatatable/DeleteModal'

const DeleteModalPage = () => {
  const { id, formId } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [deleteForm] = useMutation(DeleteFormDocument, {
    extractorFn: (data) => data.formsMutations.deleteFormsForm,
  })
  const onSubmit = async () => {
    const response = await deleteForm({
      variables: { id: String(formId) },
      refetchQueries: [TrainingFormsDatatableDocument],
    })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_revamp.delete_event_modal.forms.error_delete'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.trainings_revamp.delete_event_modal.forms.success_delete'),
      })

      navigate(navigation.trainings.list.details_revamp.view.surveys.fullPath({ id: Number(id) }))
    }
  }

  return (
    <DeleteModal
      title={i18n.t('trainings.forms.delete_survey.title')}
      description={i18n.t('trainings.forms.delete_survey.description')}
      onSubmit={onSubmit}
      onClosePath={navigation.trainings.list.details_revamp.view.surveys.fullPath({
        id: Number(id),
      })}
      cancelPath={navigation.trainings.list.details_revamp.view.surveys.fullPath({
        id: Number(id),
      })}
    />
  )
}

export default DeleteModalPage
